import { DOCTOR_TOKEN_KEY, STAFF_TOKEN_KEY } from '@medical/constant'

const getUserType = () => {
  const doctorToken = localStorage.getItem(DOCTOR_TOKEN_KEY)
  const staffToken = localStorage.getItem(STAFF_TOKEN_KEY)
  if (doctorToken) {
    return 'DOCTOR'
  }
  if (staffToken) {
    return 'STAFF'
  }
  return 'ANONYMOUS'
}

const getToken = () => {
  const doctorToken = localStorage.getItem(DOCTOR_TOKEN_KEY)
  const staffToken = localStorage.getItem(STAFF_TOKEN_KEY)
  if (doctorToken) {
    return doctorToken
  }
  if (staffToken) {
    return staffToken
  }
  return null
}

// resetStore() は表示中の問い合わせを取り直す。React 18 では画面の差し替えが後回しになるため、
// トークンを消した後のスタッフ・医師画面の問い合わせがトークン無しで送られてしまう。
// ログイン画面へ移るので取り直しは不要。トークンを消して遷移してから、キャッシュだけ消す
const signout = ({ history, client, pathname }) => {
  localStorage.clear()
  history.push({
    pathname,
  })
  client.clearStore()
}

const Auth = {
  getUserType,
  getToken,
  signout,
}

export default Auth
